// --- 商品管理 --- //

export default [
  {
    name: 'classifyManagement',
    path: '/supplySystem/:supplyId/commodityManagement/classifyManagement',
    meta: { title: '分类管理' },
    component: require('business/supplySystem/commodityManagement/classifyManagement/list.vue').default
  },
  {
    name: 'specificationManagement',
    path: '/supplySystem/:supplyId/commodityManagement/specManagement',
    meta: { title: '规格管理' },
    component: require('business/supplySystem/commodityManagement/specificationManagement/list.vue').default
  },
  {
    name: 'deliveryTakenDate',
    path: '/supplySystem/:supplyId/commodityManagement/deliveryTakenDate',
    meta: { title: '领货日期' },
    component: require('business/supplySystem/commodityManagement/deliveryTakenDate/list.vue').default
  },
  {
    name: 'dishesManagement',
    path: '/supplySystem/:supplyId/commodityManagement/productManagement',
    meta: { title: '菜品管理' },
    component: require('business/supplySystem/commodityManagement/dishesManagement/dish.vue').default
  },
  {
    name: 'releaseRecord',
    path: '/supplySystem/:supplyId/commodityManagement/releaseRecord',
    meta: { title: '发布记录' },
    component: require('business/supplySystem/commodityManagement/dishesManagement/releaseRecord.vue').default
  },
  {
    name: 'bannerManagement',
    path: '/supplySystem/:supplyId/commodityManagement/bannerManagement',
    meta: { title: '分类管理' },
    component: require('business/supplySystem/commodityManagement/bannerManagement/list.vue').default
  },
  {
    name: 'servingManagement',
    path: '/supplySystem/:supplyId/commodityManagement/stockManagement',
    meta: { title: '上菜管理' },
    component: require('business/supplySystem/commodityManagement/servingManagement/list.vue').default
  },
  {
    name: 'adjustData',
    path: '/supplySystem/:supplyId/commodityManagement/servingManagement/adjustData',
    meta: { title: '调整数据' },
    component: require('business/supplySystem/commodityManagement/servingManagement/adjustData.vue').default
  },
  {
    name: 'realtimeStock',
    path: '/supplySystem/:supplyId/commodityManagement/realtimeStock',
    meta: { title: '实时库存' },
    component: require('business/supplySystem/commodityManagement/realtimeStock/list.vue').default
  },
  {
    name: 'addDishes',
    path: '/supplySystem/:supplyId/commodityManagement/dishesManagement/add',
    meta: { title: '新增/编辑菜品' },
    component: require('business/supplySystem/commodityManagement/dishesManagement/add.vue').default
  },
  {
    name: 'boughtFeedback',
    path: '/supplySystem/:supplyId/commodityManagement/buyerFeedback',
    meta: { title: '购买反馈' },
    component: require('business/supplySystem/commodityManagement/boughtFeedback/list.vue').default
  },
  {
    name: 'deployment',
    path: '/supplySystem/:supplyId/commodityManagement/deployment',
    meta: { title: '库存调配统计' },
    component: require('business/supplySystem/commodityManagement/deployment/list.vue').default
  }
]
